module.exports = new __parcel__URL__("community--dark.a47be6a3.svg").toString();